import { usePromoEligibilityRead } from '../../shared/hooks/use-promo-eligibility'
import { EXTENSION_BANNER_DISMISS_COOKIE } from '../banner/constants'

export function useExtensionBannerEligibility() {
  const { isPending, qualifiesToShow, isHiddenOnSmallViewport } = usePromoEligibilityRead({
    cookieName: EXTENSION_BANNER_DISMISS_COOKIE,
    hideOnSmallViewport: true,
  })

  return { isPending, isEligible: qualifiesToShow && !isHiddenOnSmallViewport }
}
